import { icons } from "./icons";
import { FILTER_KEYS } from "../types/common";

export const PATIENTS_LIMIT = 15;
export const DASHBOARD_CARDS_UI = [
  {
    title: "Total Patients",
    icon: icons.patientUser,
    shadowColor: "drop-shadow(0px 12px 20px rgba(99, 95, 171, 0.3))",
  },
  {
    title: "Meeting Goals",
    icon: icons.patientGoals,
    shadowColor: "drop-shadow(0px 12px 20px rgba(10, 171, 122, 0.3))",
  },
  {
    title: "In Progress",
    icon: icons.patientProgress,
    shadowColor: "drop-shadow(0px 12px 20px rgba(236, 48, 57, 0.3))",
  },
  {
    title: "New Exams",
    icon: icons.patientExams,
    shadowColor: "drop-shadow(0px 12px 20px rgba(255, 152, 77, 0.3))",
  },
  {
    title: "Appointments Today",
    icon: icons.patientAppointment,
    shadowColor: "drop-shadow(0px 12px 20px rgba(11, 189, 240, 0.3))",
  },
];

export const TABLE_HEADER_PATIENT = [
  {
    title: "Status",
    width: 88,
    marginLeft: 0,
  },
  {
    title: "Name",
    width: 178,
  },
  {
    title: "Age",
    width: 103,
  },
  {
    title: "Region",
    width: 114,
    filterKey: FILTER_KEYS.joint,
  },
  {
    title: "Outcome Scores",
    width: 134,
    filterKey: FILTER_KEYS.score,
  },
  {
    title: "Week",
    width: 96,
  },
  {
    title: "Last Exam",
    width: 113,
  },
  {
    title: "",
    width: 99,
  },
];

export const TABLE_HEADER_ATHLETE = [
  {
    title: "Name",
    sortBy: "name",
    width: 280,
  },
  {
    title: "Age",
    sortBy: "age",
    width: 90,
    filterKey: FILTER_KEYS.score,
  },
  {
    title: "Last Exam",
    sortBy: "lastExam",
    width: 120,
  },
  {
    title: "Last Exam Avg",
    sortBy: "lastExamAvg",
    width: 80,
    center: true,
  },
  {
    title: "Left Knee Min",
    sortBy: "leftSd",
    width: 120,
  },
  {
    title: "Right Knee Min",
    sortBy: "rightSd",
    width: 120,
  },
  {
    title: "Drop Jump Mins",
    sortBy: "",
    width: 220,
  },
  {
    title: "Athlete's sport",
    sortBy: "",
    width: 220,
  },
  {
    title: "Teams",
    sortBy: "",
    width: 170,
  },
  {
    title: "Status",
    sortBy: "",
    width: 80,
  },
  {
    title: "Action",
    sortBy: "",
    width: 60,
  },
];

export const TABLE_HEADER_ATHLETE_FREE_FORM = [
  {
    title: "Name",
    sortBy: "name",
    width: 335,
  },
  {
    title: "Age",
    sortBy: "age",
    width: 103,
    filterKey: FILTER_KEYS.score,
  },
  {
    title: "Last Exam",
    sortBy: "lastExam",
    width: 150,
  },
  {
    title: "Athlete's sport",
    sortBy: "",
    width: 280,
  },
  {
    title: "Teams",
    sortBy: "",
    width: 180,
  },
  {
    title: "Status",
    sortBy: "",
    width: 150,
  },
  {
    title: "Action",
    sortBy: "",
    width: 100,
  },
];

export const CLINICIANS_LIMIT = 15;
export const CLINICIAN_PATIENT_LIMIT = 15;
export const TABLE_HEADER_USERS_CLINIC_ADMIN = [
  {
    title: "Name",
    sortBy: "name",
    width: 300,
    marginLeft: 40,
  },
  {
    title: "Roles",
    sortBy: "role",
    width: 250,
  },

  {
    title: "Date invited",
    width: 200,
    marginLeft: 0,
  },
  {
    title: "Status",
    width: 150,
    marginLeft: 0,
  },
  {
    title: "Action",
    width: 100,
    marginLeft: 0,
  },
];

export const TABLE_HEADER_PATIENT_CLINIC_ASSISTANT = [
  {
    title: "Name",
    sortBy: "name",
    width: 225,
    marginLeft: 40,
  },
  {
    title: "Assigned Team Lead",
    sortBy: "assignedTeamLead",
    width: 200,
  },
  {
    title: "Email",
    sortBy: "email",
    width: 250,
    marginLeft: 25,
  },
  {
    title: "Date invited",
    sortBy: "inviteDates",
    width: 175,
    marginLeft: 90,
  },
  {
    title: "Status",
    sortBy: "authStatus",
    width: 210,
  },
  {
    title: "Action",
    sortBy: "action",
    width: 150,
    marginLeft: 30,
  },
];

export const TABLE_HEADER_PATIENT_CLINIC_TEAM_LEAD = [
  {
    title: "Patient Name",
    sortBy: "name",
    width: 300,
    marginLeft: 40,
  },
  {
    title: "Assigned Team Members",
    width: 200,
  },
];

export const TABLE_HEADER_PATIENT_CLINIC_TEAM_ASSISTANT_AND_LEAD = [
  {
    title: "Patient Name",
    sortBy: "name",
    width: 300,
    marginLeft: 40,
  },
  {
    title: "Assigned Team Lead",
    sortBy: "assignedTeamLead",
    width: 200,
  },
  {
    title: "Assigned Team Members",
    width: 200,
  },
];

export const TABLE_HEADER_PATIENT_CLINIC_TEAM_MEMBER = [
  {
    title: "Patient Name",
    sortBy: "name",
    width: 250,
  },
  {
    title: "Age",
    sortBy: "age",
    width: 100,
  },
  {
    title: "Max",
    sortBy: "max",
    width: 100,
  },
  {
    title: "Min",
    sortBy: "min",
    width: 100,
  },
  {
    title: "PROM",
    sortBy: "prom",
    width: 100,
  },
  {
    title: "VAS",
    sortBy: "vas",
    width: 100,
  },
  {
    title: "Progress",
    sortBy: "progress",
    width: 100,
  },
  {
    title: "Reporting compliance",
    sortBy: "checkin",
    width: 200,
  },
  {
    title: "Current Range of Motion",
    sortBy: "examsCount",
    width: 200,
  },
];

export const MAIN_OPTIONS = [
  {
    value: 0,
    label: "All",
  },
  {
    value: 1,
    label: "None",
  },
];

export const TOGGLE_OPTIONS = {
  optionLeft: {
    label: "Dynamic",
    value: 0,
  },
  optionRight: {
    label: "ROM",
    value: 1,
  },
};
export const SUPER_ADMIN_CLINIC_LIMIT = 15;
export const SUPER_ADMIN_USER_CLINIC_LIMIT = 15;
export const TABLE_SUPER_ADMIN_CLINIC_LIST = [
  {
    title: "Clinic Name",
    sortBy: "name",
    width: 300,
    marginLeft: 40,
  },
  {
    title: "Clinic Location",
    sortBy: "address",
    width: 300,
    marginLeft: 40,
  },
  {
    title: "Clinic Admin",
    sortBy: "clinicAdmins.profileInfo.lastName",
    width: 250,
    marginLeft: 40,
  },
  {
    title: "Date Created",
    sortBy: "createdAt",
    width: 200,
    marginLeft: 40,
  },
  {
    title: "Status",
    sortBy: "status",
    width: 100,
    marginLeft: 40,
  },
  {
    title: "",
    width: 100,
  },
];
export const TABLE_SUPER_ADMIN_ATHLETES_LIST = [
  {
    title: "Name",
    sortBy: "name",
    width: 400,
    marginLeft: 40,
  },
  {
    title: "Clinic Name",
    sortBy: "age",
    width: 300,
    marginLeft: 40,
  },
  {
    title: "Date Invited",
    sortBy: "status",
    width: 200,
    marginLeft: 40,
  },
  {
    title: "Invitation Status",
    sortBy: "status",
    width: 150,
    marginLeft: 40,
  },
  {
    title: "Status",
    sortBy: "status",
    width: 100,
    marginLeft: 40,
  },
  {
    title: "",
    width: 100,
  },
];
export const CLINICIAN_STATS = [
  {
    title: "Clinician",
    width: 300,
    marginLeft: 40,
  },
  {
    title: "Number of Patients",
    width: 150,
  },
  {
    title: "Number of Exams",
    width: 150,
  },
  {
    title: "Number of Surveys",
    width: 150,
  },
  {
    title: "Number of Daily Checkins",
    width: 150,
  },
  /*  {
    title: "Number of Elegible Events",
    width: 150,
  }, */
];

export const PATIENT_STATS = [
  {
    title: "Patient",
    width: 300,
    marginLeft: 40,
  },
  /*  {
    title: "Total Elegible Events",
    width: 150,
  }, */
  {
    title: "Clinician",
    width: 150,
  },
  {
    title: "Logged Activities",
    width: 150,
  },
  {
    title: "Next Billing Date",
    width: 150,
  },
];

export const ELEGIBLE_EVENTS = [
  {
    title: "Patient",
    width: 300,
    marginLeft: 40,
  },
  /*  {
    title: "Total Elegible Events",
    width: 150,
  }, */
  {
    title: "Clinician",
    width: 150,
  },
  {
    title: "Logged Activities",
    width: 150,
  },
  {
    title: "Start Date",
    width: 150,
  },
  {
    title: "End Date",
    width: 150,
  },
  {
    title: "Status",
    width: 150,
  },
];

export const TABLE_HEADER_BY_HOME_TAB = [
  PATIENT_STATS,
  CLINICIAN_STATS,
  ELEGIBLE_EVENTS,
];

export const TABLE_SUPER_ADMIN_CLINIC_USER_LIST = [
  {
    title: "Name",
    sortBy: "profileInfo.lastName",
    width: 150,
    marginLeft: 40,
  },
  {
    title: "Clinic Name",
    sortBy: "clinic.name",
    width: 150,
    marginLeft: 40,
  },
  {
    title: "Clinic Location",
    sortBy: "clinic.address",
    width: 150,
    marginLeft: 40,
  },
  {
    title: "Roles",
    sortBy: "clinic.address",
    width: 200,
    marginLeft: 40,
  },
  {
    title: "Email",
    sortBy: "clinic.address",
    width: 450,
    marginLeft: 40,
  },
  {
    title: "Date invited",
    sortBy: "clinic.address",
    width: 150,
    marginLeft: 40,
  },
  {
    title: "Status",
    sortBy: "status",
    width: 100,
    marginLeft: 40,
  },
  {
    title: "",
    width: 100,
  },
];
